module.exports = __webpack_public_path__ + "static/media/iconcash.c39c28af.png";